var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import { lazy } from "react";
const MatchComponent = lazy(() => import("./matchComponent/MatchComponent"));
const PlayerStatsComponent = lazy(
  () => import("./../../../components/playerStatsComponent/PlayerStatsComponent.js")
);
const SquadsComponent = lazy(() => import("./squadsComponent/SquadsComponent"));
const TableComponent = lazy(
  () => import("./../../../components/tableComponent/TableComponent.js")
);
const VideosComponent = lazy(
  () => import("./../../../components/videosComponent/VideosComponent.js")
);
const Components = {
  Table: TableComponent,
  Fixtures: (props) => /* @__PURE__ */ jsx(MatchComponent, __spreadProps(__spreadValues({}, props), { isResult: false })),
  Results: (props) => /* @__PURE__ */ jsx(MatchComponent, __spreadProps(__spreadValues({}, props), { isResult: true })),
  PlayerStats: PlayerStatsComponent,
  Videos: VideosComponent,
  Squads: SquadsComponent
};
export {
  Components
};
